import IField from "@mapmycustomers/shared/types/fieldModel/IField";
import User from "@mapmycustomers/shared/types/User";
import MapFilterModel from "@mapmycustomers/shared/types/viewModel/internalModel/MapFilterModel";

import { FILTER_ENTITY_TYPES } from "@app/component/filtering/components/MapFilterButton/utils/consts";
import { areConditionsEqual } from "@app/util/viewModel/comparators";

const getMapFilterDifferencesCount = (
  filters1: MapFilterModel,
  filters2: MapFilterModel,
  viewAs1: undefined | User["id"],
  viewAs2: undefined | User["id"],
  excludeFields?: IField[]
): number => {
  const excludedFieldsNames = new Set((excludeFields ?? []).map(({ name }) => name));

  const result = FILTER_ENTITY_TYPES.reduce(
    (result, entityType) => {
      return (
        result +
        Object.keys({ ...(filters1[entityType] ?? {}), ...(filters2[entityType] ?? {}) }).filter(
          (fieldName) => {
            if (excludedFieldsNames.has(fieldName)) {
              return false;
            }
            const filter1 = filters1[entityType]?.[fieldName];
            const filter2 = filters2[entityType]?.[fieldName];
            if (!filter1 || !filter2) {
              return true;
            } else {
              return !areConditionsEqual(filter1, filter2);
            }
          }
        ).length
      );
    },
    viewAs1 === viewAs2 ? 0 : 1
  );

  return result;
};

export default getMapFilterDifferencesCount;
